import classNames from 'classnames';
import { ContractStatus } from 'compliance-api/generated';
import { formatContractStatusLabel } from '@/modules/admin-dashboard/components/contractManagement/contractStatus.ts';

interface ContractStatusBadgeProps {
  status: ContractStatus | string;
}

export const ContractStatusBadge = ({ status }: ContractStatusBadgeProps) => (
  <span
    className={classNames('inline-flex rounded px-2 py-[1px] text-xs leading-5', {
      'bg-gray-100 text-gray-500': status === ContractStatus.Draft || status === 'draft',
      'bg-green-50 text-green-700': status === ContractStatus.Active || status === 'active',
      'bg-red-50 text-red-700': status === ContractStatus.Expired || status === 'expired',
      'bg-blue-50 text-blue-700':
        status === ContractStatus.Approved ||
        status === ContractStatus.Signed ||
        status === ContractStatus.SentForSigning ||
        status === 'approved' ||
        status === 'signed' ||
        status === 'sent_for_signing',
      'bg-yellow-50 text-yellow-700':
        status === ContractStatus.PendingApproval || status === 'pending_approval',
      'bg-gray-200 text-gray-600': status === ContractStatus.Archived || status === 'archived',
    })}
  >
    {formatContractStatusLabel(status)}
  </span>
);
